module.exports = __webpack_public_path__ + "ffc93d852529df85be7c75204e93309b.svg";